(() => {
  const SELECTOR_ROOT = '[data-pricing-table]';
  const SELECTOR_TAB = '[role="tab"]';
  const SELECTOR_ACTIONS = '[data-pricing-table-actions]';
  const SELECTOR_ACTIONS_SLOT = '[data-pricing-table-actions-slot]';

  function getPanel(root, tab) {
    const panelId = tab.getAttribute('aria-controls');
    if (!panelId) return null;

    try {
      return root.querySelector(`#${CSS.escape(panelId)}`);
    } catch {
      return root.querySelector(`#${panelId}`);
    }
  }

  function selectTab(root, tabs, tabToSelect) {
    tabs.forEach((tab) => {
      const isSelected = tab === tabToSelect;
      tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      tab.tabIndex = isSelected ? 0 : -1;

      const panel = getPanel(root, tab);
      if (panel) panel.hidden = !isSelected;
    });

    moveActionsIntoSelectedPanel(root, tabs);
  }

  function getSelectedTab(tabs) {
    return tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0] || null;
  }

  function findActionsElement(root) {
    const scope = root.closest('.product__info-container') || root.closest('product-info') || document;
    return scope.querySelector(SELECTOR_ACTIONS);
  }

  function moveActionsIntoSelectedPanel(root, tabs) {
    const actions = findActionsElement(root);
    if (!actions) return;

    const selectedTab = getSelectedTab(tabs);
    if (!selectedTab) return;

    const selectedPanel = getPanel(root, selectedTab);
    if (!selectedPanel) return;

    const slot = selectedPanel.querySelector(SELECTOR_ACTIONS_SLOT);
    if (!slot) return;

    if (actions.parentElement !== slot) {
      slot.appendChild(actions);
    }
  }

  function setupPricingTable(root) {
    const tabs = Array.from(root.querySelectorAll(SELECTOR_TAB));
    if (!tabs.length) return;

    const initiallySelected = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
    selectTab(root, tabs, initiallySelected || tabs[0]);

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(root, tabs, tab));

      tab.addEventListener('keydown', (event) => {
        const key = event.key;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) return;

        event.preventDefault();

        let nextIndex = index;
        if (key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (key === 'Home') nextIndex = 0;
        if (key === 'End') nextIndex = tabs.length - 1;

        const nextTab = tabs[nextIndex];
        selectTab(root, tabs, nextTab);
        nextTab.focus();
      });
    });
  }

  function init() {
    document.querySelectorAll(SELECTOR_ROOT).forEach(setupPricingTable);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
